import {takeLatest} from 'redux-saga/effects';

import {createNewPubBeer} from './create/saga';
import {removePubBeer} from './delete/saga';
import {editPubBeerSaga} from './edit/saga';
import {getAllBeers, getPubBeers} from './get/saga';
import {getAdminBeersOnTapSaga} from './getAdminBeersOnTap/saga';
import {
  getPubBeersACS,
  createPubBeerACS,
  deletePubBeerACS,
  getAllBeersACS,
  changePubBeerPositionACS,
  editPubBeerACS,
  toggleBeerOnTapACS,
  getAdminBeersOnTapACS,
} from './requestAC';
import {toggleBeerOnTapSaga} from './toggleBeerOnTap/saga';
import {updatePubBeerPosition} from './update/saga';

export default function* beersManagerSaga() {
  yield takeLatest(getPubBeersACS.type, getPubBeers);
  yield takeLatest(getAllBeersACS.type, getAllBeers);
  yield takeLatest(deletePubBeerACS.type, removePubBeer);
  yield takeLatest(changePubBeerPositionACS.type, updatePubBeerPosition);
  yield takeLatest(createPubBeerACS.type, createNewPubBeer);
  yield takeLatest(editPubBeerACS.type, editPubBeerSaga);
  yield takeLatest(toggleBeerOnTapACS.type, toggleBeerOnTapSaga);
  yield takeLatest(getAdminBeersOnTapACS.type, getAdminBeersOnTapSaga);
}
